import React from 'react';
import { Link } from 'react-router-dom';
import './ServicePage.scss';
import serviceImage1 from '../assets/services/image1.jpg';
import serviceImage2 from '../assets/services/image2.jpg';
import serviceImage3 from '../assets/services/image3.jpg';
import serviceImage4 from '../assets/services/image4.jpeg';
import serviceImage5 from '../assets/services/image5.png';
import serviceImage6 from '../assets/services/image6.jpg';

const ServicePage = () => {
    const services = [
        {
            title: 'COX® Flexion Distraction Technic',
            image: serviceImage1,
            features: [
                'No \"Twisting\" or \"Cracking\" Involved',
                'Evidence-Based Non-Surgical Procedure',
                'Targets Disc Herniation and Spinal Stenosis',
                'Increase Mobility in the Spine'
            ]
        },
        {
            title: 'Diversified Chiropractic Adjustment',
            image: serviceImage2,
            features: [
                'Quick, Gentle Adjustment',
                'Restores Joint Range of Motion',
                'Improves Nerve Function',
                'Reduces Acute & Chronic Pain'
            ]
        },
        {
            title: 'Erchonia® Percussor',
            image: serviceImage3,
            features: [
                'Gentle, Rhythmic Vibration',
                'Releases Deep Muscle Tension',
                'Increases Joint Flexibility',
                'Improves Local Circulation'
            ]
        },
        {
            title: 'Erchonia® Cold Laser',
            image: serviceImage4,
            features: [
                'Accelerates Cellular Healing',
                'Reduces Pain and Inflammation',
                'Drug-Free & Non-Invasive',
                'FDA-Approved Pain Relief'
            ]
        },
        {
            title: 'Chattanooga Intelect Electrotherapy',
            image: serviceImage5,
            features: [
                'Blocks Pain Signals',
                'Reduces Muscle Spasms',
                'Enhances Local Circulation',
                'Non-Invasive Pain Management'
            ]
        },
        {
            title: 'Chattanooga Intelect Ultrasound',
            image: serviceImage6,
            features: [
                'Promotes Deep Tissue Healing',
                'Reduces Scar Tissues & Adhesions',
                'Increases Local Blood Flow',
                'Targets Chronic Stiffness'
            ]
        }
    ];

    return (
        <div className="service-page">
            <div className="service-hero">
                <h1>Our Services</h1>
                <p>Chiropractic care tailored to your unique needs</p>
            </div>

            <div className="services-container">
                {services.map((service, index) => (
                    <div key={index} className="service-detailed-card">
                        <div className="service-content">
                            <h2>{service.title}</h2>
                            <div className="service-features">
                                <h3>Details:</h3>
                                <ul>
                                    {service.features.map((feature, idx) => (
                                        <li key={idx}>{feature}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="service-image">
                            <img src={service.image} alt={service.title} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ServicePage;

